var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88882 3.04211L3.60529 15.2535C3.61608 15.4355 3.69495 15.6064 3.8258 15.7315C3.95665 15.8565 4.12962 15.9262 4.30941 15.9263H10.6906C10.8704 15.9262 11.0434 15.8565 11.1742 15.7315C11.3051 15.6064 11.3839 15.4355 11.3947 15.2535L12.1112 3.04211H2.88882ZM13.1726 3.04211L12.4518 15.317C12.425 15.7723 12.2278 16.2 11.9005 16.5128C11.5731 16.8256 11.1404 16.9999 10.6906 17H4.30941C3.85963 16.9999 3.42686 16.8256 3.09952 16.5128C2.77219 16.2 2.575 15.7723 2.54824 15.317L1.82735 3.04211H0V2.41579C0 2.29714 0.0464811 2.18335 0.129218 2.09945C0.211954 2.01555 0.324169 1.96842 0.441176 1.96842H14.5588C14.6758 1.96842 14.788 2.01555 14.8708 2.09945C14.9535 2.18335 15 2.29714 15 2.41579V3.04211H13.1726ZM9.26471 0C9.38171 0 9.49393 0.0471334 9.57667 0.131031C9.6594 0.214929 9.70588 0.328719 9.70588 0.447368V1.07368H5.29412V0.447368C5.29412 0.328719 5.3406 0.214929 5.42334 0.131031C5.50607 0.0471334 5.61829 0 5.73529 0H9.26471ZM5.29412 5.36842H6.35294L6.79412 13.4211H5.73529L5.29412 5.36842ZM8.64706 5.36842H9.70588L9.26471 13.4211H8.20588L8.64706 5.36842Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRatio);
export default __webpack_public_path__ + "static/media/delete-ratio.bf2bccecf606cc43df5d150346f45176.svg";
export { ForwardRef as ReactComponent };